export class AwsConfig {
    static S3_ACCESS_KEY_ID = 'AKIAY554DOVWMH2NGFFR';
    static S3_ACCESS_KEY_SECRET = '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';

    static VAPID_PUBLIC_KEY= "BGKxlQyfSTJ5OiRIP9zoNnse7RCxFfeSIYzBMNwIS_r0V1ByPnw3Lr-FPELygghWKLRaL9XBV1FnkcH4rrbQg2M";

    // static S3_ACCESS_KEY_ID = 'AKIAY554DOVWJ7CQWM65';
    // static S3_ACCESS_KEY_SECRET = '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';
}
